export interface HeaderMenuItem {
    name: string;
    icon?: string;
    href: string;
    active: boolean;
    desktop: boolean;
    hide: boolean;
    inertia: boolean;
    children?: HeaderMenuItem[]
}
export interface CrumbPage {
    name: string;
    href?: string;
}

export interface UserEntityInterface {
    id: string | 'guest';
    name_first: string;
    name_last: string | null;
    email: string;
    current_team_id: string | null;
    currentTeam?: TeamEntityInterface | null;
    current_project_id: string | null;
    currentProject?: ProjectEntityInterface | null;
}

export interface TeamInvitationEntityInterface {
    id: string;
    name: string;
    email: string;
    state: 'pending' | 'accepted' | 'cancelled';
    created_at: string;
    team_id: string;
    team?: TeamEntityInterface;
    invited_by_user_id: string;
    invited_by_user?: UserEntityInterface;
}

export interface TeamEntityInterface {
    id: string;
    name: string;
    owner_user_id: string;
    owner_user?: UserEntityInterface;
    billing_trial_ends_at: string | null;
    billing_pending_checkout_id: string | null;
    members?: [UserEntityInterface & {
        membership: {
            // role: string;
            id: string;
            created_at: string;
        }
    }];
    invitations?: TeamInvitationEntityInterface[];
    projects_count?: number;
}

export interface ProjectBuilderSettingsInterface {
    slugify: boolean,
    lowercase: boolean,
    decode: boolean
}

export interface ProjectEntityInterface {
    id: string;
    name: string;
    slug: string;
    builder_settings: ProjectBuilderSettingsInterface;
    team_id: string;
    team?: TeamEntityInterface;
}

export interface UrlEntityInterface {
    id: string;

    project_id: string,
    project?: ProjectEntityInterface;
    user_id: string,
    user?: UserEntityInterface,

    destination_url: string;
    full_url: string;
    utm_string: string;

    parameters?: ParameterEntityInterface[],
    shorturls?: ShorturlEntityInterface[],

    created_at: string;

}

export interface ShorturlEntityInterface {
    id: string;

    project_id: string,
    project?: ProjectEntityInterface;
    user_id: string,
    user?: UserEntityInterface,
    url_id: string,
    url?: UserEntityInterface,


    full_url: string,
    slug: string,
    short_url: string;
    clicks: number,

    created_at: string;

}

export const PARAMETER_TYPES = {
    utm_campaign: 'utm_campaign',
    utm_source: 'utm_source',
    utm_medium: 'utm_medium',
    utm_content: 'utm_content',
    utm_term: 'utm_term',
}
export type ParameterType = keyof typeof PARAMETER_TYPES;

export interface ParameterEntityInterface {
    id: string;

    project_id: string,
    project?: ProjectEntityInterface;
    user_id: string,
    user?: UserEntityInterface,

    type: ParameterType;
    name: string;
    active: boolean;
    clicks: number;
    notes: string | null;

    created_at: string;

}

export interface ParametersCollections {
    utm_campaign: ParameterEntityInterface[],
    utm_source: ParameterEntityInterface[],
    utm_medium: ParameterEntityInterface[],
    utm_content: ParameterEntityInterface[],
    utm_term: ParameterEntityInterface[],
}

export interface TemplateParameterInterface {
    type: ParameterType,
    name: string;
}

export interface TemplateEntityInterface {
    id: string;

    project_id: string,
    project?: ProjectEntityInterface;
    user_id: string,
    user?: UserEntityInterface,

    name: string;
    parameters: TemplateParameterInterface[],
    utm_string: string;
    active: boolean;
    notes: string;

    created_at: string;
}

